import { render, staticRenderFns } from "./DealRecords.vue?vue&type=template&id=7ed6de74&scoped=true&"
import script from "./DealRecords.vue?vue&type=script&lang=js&"
export * from "./DealRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6de74",
  null
  
)

export default component.exports